import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { formatDate, formatTime } from '../helpers/Helpers';
import { SERVER_URL } from '../constants';
import CustomerList from './CustomerList';
import EditTodaysSchedule from './EditTodaysSchedule';
import TransportControls from './TransportControls';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AppointmentCodeOptions from './AppointmentCodeOptions';
import MinutesCounter from './MinutesCounter';
import { Paper } from '@mui/material';

function OfficeTodaysSchedule (props) {

    // useEffect(() => {
    //     props.fetchOffices();
    // }, [nowServing]);

    const [scheduleId, setScheduleId] = useState({
        schedule_id: props.schedule.id
    });

    const onNextButtonClick = (event) => {
        serveNextCustomer(false);
    }

    const onNoShowButtonClick = (event) => {
        serveNextCustomer(true);
    }

    const onBackButtonClick = (event) => {
        rollback();
    }

    const onPausePlayButtonClick = (event) => {
        togglePausePlay();
    }

    const [disableTransportControls, setDisableTransportControls] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");

    const [snackbarOpen, setSnackbarOpen] = React.useState(false);

    const handleSnackbarOpen = () => {
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen(false);
    };


    const serveNextCustomer = (noShow = false) => {
        console.log("serveNextCustomer");
        setDisableTransportControls(true);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/serve-next', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                schedule_id: props.schedule.id,
                no_show: noShow
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if (data.status == 2)
            {
                console.log(data.message);
                setErrorMessage("You've reached the end of the queue.");
                handleSnackbarOpen();
                props.fetchOffices();
            }
            else{
                props.fetchOffices();
            }
            setDisableTransportControls(false);
        })
        .catch((err) => {
            console.error(err);
            setDisableTransportControls(false);
        });
    }

    const rollback = () => {
        // console.log("rollback");
        setDisableTransportControls(true);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/serve-back', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(scheduleId)
        })
        .then(response => response.json())
        .then(data => {
            //console.log(data);
            if (data.status == 2)
            {
                console.log(data.message);
                setErrorMessage("You've reached the beginning of the queue.");
                handleSnackbarOpen();
                props.fetchOffices();
            }
            else{
                props.fetchOffices();
            }
            setDisableTransportControls(false);
        })
        .catch((err) => {
            console.error(err);
            setDisableTransportControls(false);
        });
    }

    const togglePausePlay = () => {
        // console.log("togglePausePlay");
        setDisableTransportControls(true);
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/toggle-pause-schedule', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(scheduleId)
        })
        .then(response => response.json())
        .then(data => {
            setDisableTransportControls(false);
            props.fetchOffices();
        })
        .catch((err) => {
            console.error(err);
            setDisableTransportControls(false);
        });
    }

    const getServingDisplay = (props, disableTransportControls) => {
        if (disableTransportControls) {
            return <CircularProgress size="2rem" />;
        }

        const { now_serving, now_serving_name, end_reached } = props.schedule;

        if (!now_serving || !now_serving_name) {
            return "...";
        }

        return end_reached ? "..." : now_serving;
    }


    return(
        <React.Fragment>
            <Box 
                sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%' // or a fixed height if needed
                }}
            >
                <Box
                    sx={{
                    flexGrow: 1,          // take up remaining space
                    overflowY: 'auto',    // enable vertical scrollbars when content overflows
                    p: 2,                 // optional padding
                    }}
                >
                    <Stack alignItems="center" justifyContent="center" direction="column" spacing={1}>
                        <Typography gutterBottom variant="subtitle1">
                        {formatDate(props.schedule.date)} | {formatTime(props.schedule.start_time)} - {formatTime(props.schedule.end_time)}
                        </Typography>
                        
                        <Paper
                            elevation={3}
                            sx={{
                                padding: 1.5,
                                borderRadius: 2,
                                textAlign: 'center',
                                backgroundColor: props.schedule.paused ? '#f8d7da' : '#fff',
                                border: props.schedule.paused ? '2px solid #f5c2c7' : '2px solid #ccc',
                                width: '100%',
                                maxWidth: 280,
                                margin: '0 auto',
                            }}
                            >
                            <Typography
                                variant="body2"
                                sx={{
                                fontWeight: 'bold',
                                color: props.schedule.paused ? '#842029' : '#555',
                                textTransform: 'uppercase',
                                letterSpacing: 1,
                                lineHeight: 1.2,
                                marginBottom: 0.5,
                                }}
                            >
                                {props.schedule.paused
                                ? 'PAUSED'
                                : !props.schedule.now_serving_name
                                ? '...'
                                : 'Now Serving'}
                            </Typography>

                            <Typography
                                variant="h3"
                                sx={{
                                fontSize: '2.5rem',
                                fontWeight: 'bold',
                                color: props.schedule.paused ? '#842029' : '#000',
                                lineHeight: 1.1,
                                marginBottom: 0.5,
                                }}
                            >
                                {getServingDisplay(props, disableTransportControls)}
                            </Typography>

                            <Typography
                                variant="h6"
                                sx={{
                                fontWeight: 500,
                                color: props.schedule.paused ? '#842029' : '#000',
                                lineHeight: 1.2,
                                marginBottom: 0,
                                }}
                            >
                                {props.schedule.now_serving_name || '...'}
                            </Typography>
                            {props.schedule.running_minutes && !props.schedule.paused ? <MinutesCounter startingNumber={props.schedule.running_minutes} /> : null }
                        </Paper>
            
                        <Typography gutterBottom variant="body2">
                            {"Service Velocity: " + props.schedule.average_serve_minutes +   " mins / client"}
                        </Typography>
                        <Stack justifyContent="center" alignItems="center" direction="row" spacing={1}>
                            { props.schedule.now_serving === 0 && props.schedule.end_reached === 0 ? 
                                <Button
                                disabled={disableTransportControls || props.schedule.num_waiting == 0}
                                onClick={onNextButtonClick}
                                size="small"
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                sx={{ mr: 2 }}
                                variant='outlined'
                                >
                                    <Stack
                                        direction="column"
                                        justifyContent="center"
                                        alignItems="center"
                                        spacing={0}
                                        width={70}
                                        >
                                        <PlayArrowIcon fontSize='large' /> Start
                                    </Stack>
                                </Button>
                            :
                                <TransportControls 
                                disableAll = {disableTransportControls}
                                onBackButtonClick = {onBackButtonClick}
                                nowServing = {props.schedule.now_serving}
                                endReached = {props.schedule.end_reached}
                                paused = {props.schedule.paused}
                                onPausePlayButtonClick = {onPausePlayButtonClick}
                                onNextButtonClick = {onNextButtonClick}
                                onNoShowButtonClick = {onNoShowButtonClick}
                                />
                            }
                        </Stack>
                        
                    </Stack>
                    <Stack
                    direction="row"
                    justifyContent={props.schedule.now_serving === 0 ? "center" : "center"}
                    alignItems="center"
                    spacing={2}
                    >
                        <Typography gutterBottom variant="body1">
                            <b>{props.schedule.num_waiting}</b> in queue
                        </Typography>
                    </Stack>
                    
                </Box>
                <Box sx={{ p: 1, mt: 'auto' }}>
                    <Stack alignItems="center" justifyContent="center" direction="row" spacing={3}>
                        <AppointmentCodeOptions rawDate={props.schedule.date} setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} fetchOffices={props.fetchOffices} officeId={props.officeId} officeName={props.officeName} />
                        <CustomerList fetchOffices={props.fetchOffices} startTime={props.schedule.start_time} runningMinutes={props.schedule.running_minutes} averageServeMinutes={props.schedule.average_serve_minutes} officeId={props.officeId} date={formatDate(props.schedule.date)} rawDate={props.schedule.date} officeName={props.officeName} scheduleId={props.schedule.id}/>
                        <EditTodaysSchedule 
                            maxClients={props.schedule.max_clients}
                            officeName={props.officeName} 
                            scheduleId={props.schedule.id} 
                            fetchOffices={props.fetchOffices} 
                            date={formatDate(props.schedule.date)} 
                            startTime={props.schedule.start_time} 
                            endTime={props.schedule.end_time} 
                            averageServeMinutes={props.schedule.average_serve_minutes}
                        />
                    </Stack>
                </Box>
            </Box>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'center' }} open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
                <Alert
                onClose={handleSnackbarClose}
                severity="info"
                variant="filled"
                sx={{ width: '100%' }}
                >
                {errorMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}

export default OfficeTodaysSchedule;